import _ from 'lodash'

function ScoreCache(scores) {
	this._cache = {}
	this.add(scores)
}

_.extend(ScoreCache.prototype, {

	// adds one or more scores to the cache
	add: function(scores) {
		if (_.isNil(scores)) {
			return
		}

		var addOne = function(score) {
			if (_.isNil(score)) {
				return
			}
			if (!score.scorecardItemId) {
				throw Error('invalid scorecardItemId in score ' + score)
			}
			if (!score.periodId) {
				throw new Error('invalid periodId in score ' + score)
			}

			var scoresById = this._cache[score.scorecardItemId]
			if (!scoresById) {
				scoresById = this._cache[score.scorecardItemId] = {}
			}
			scoresById[score.periodId] = score
		}.bind(this)

		if (_.isArray(scores)) {
			_.each(scores, addOne)
		} else {
			addOne(scores)
		}
	},

	// returns a score from the cache
	get: function(scorecardItemId, periodId) {
		var scoresById = this._cache[scorecardItemId]
		if (scoresById) {
			return scoresById[periodId]
		}
	},

	// returns the a hash of scores keyed by periodId for the given
	// scorecardItemId.  A REFERENCE is returned for performance reasons, so
	// be careful what you do with it!
	scoresByPeriodId: function(scorecardItemId) {
		return this._cache[scorecardItemId]
	}

})

export default ScoreCache

ScoreCache.__filename__ = 'components/score-cache.js'
